module.exports = __webpack_public_path__ + "static/fonts/Tienne-Regular.5e0d0e74.ttf";